export default __webpack_public_path__ + "static/media/monk@1x.668ccaf3.webp";